(() => {
  const ATTRIBUTE_KEY = "ab_test_dev";
  const ATTRIBUTE_VALUE = "plp-filters-test";

  const syncCartAttribute = () =>
    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => {
        if (cart.attributes[ATTRIBUTE_KEY] === ATTRIBUTE_VALUE) return;

        const attributes = { ...cart.attributes, [ATTRIBUTE_KEY]: ATTRIBUTE_VALUE };

        return fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ attributes }),
        }).then(() => {
          if (document.querySelector("collection-info")) {
            window.location.reload();
          }
        });
      })
      .catch((err) => {
        console.error("ExposedFiltersHoldout: error syncing cart attribute", err);
      });

  document.addEventListener("DOMContentLoaded", syncCartAttribute);
})();
